import { type PropsWithChildren } from "react"
import { Banner, Typography } from "@octopus-energy/coral/atoms"
import { useIsClient } from "@octopus-energy/utils"
import { Portal } from "@oefr/ui"
import { BANNER_PORTAL_NODE_ID } from "../constants"

export function GlobalBanner({ children }: PropsWithChildren) {
    const isClient = useIsClient()

    if (!isClient) return null

    return (
        <Portal targetNode={document.getElementById(BANNER_PORTAL_NODE_ID)}>
            <Banner variant="secondary">
                <Typography textStyle="body2">{children}</Typography>
            </Banner>
        </Portal>
    )
}
